import TextareaQuestionSurface from "./TextareaQuestionSurface";

export const SURFACE_14_LABEL = "What are they good at that they downplay?";
export const SURFACE_14_PLACEHOLDER = "The thing you see in them that they shrug off...";
export const SURFACE_14_ERROR = "Even a small thing helps.";

export default function Surface14(props) {
  return (
    <TextareaQuestionSurface
      current={10}
      label={SURFACE_14_LABEL}
      placeholder={SURFACE_14_PLACEHOLDER}
      errorCopy={SURFACE_14_ERROR}
      name="recipient_downplays"
      {...props}
    />
  );
}
